import { render } from "./CreateLiquidation4.vue?vue&type=template&id=6481a6eb"
import script from "./CreateLiquidation4.vue?vue&type=script&lang=js"
export * from "./CreateLiquidation4.vue?vue&type=script&lang=js"

import "./CreateLiquidation4.vue?vue&type=style&index=0&id=6481a6eb&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__